<template>
  <div id="teacher_book">
    <div class="over_ta">
      <div>
        <div class="fix"></div>
        <ul style="margin-top: 20px;">
          <li style="list-style: inside;" v-for="(teacherpublication,index) in teacherpublications" :key="index" v-if="teacherpublication.type === 3">
            <span v-if="teacherpublication.context">
              {{teacherpublication.context}}
            </span> 
            <span v-else>
              <div style="display: inline-block" aria-hidden="true" v-html="(teacherpublication.author)">
              </div>, {{publication(teacherpublication)}},
              <div style="display: inline-block" aria-hidden="true" v-html="(teacherpublication.title)">
              </div>, {{showName(teacherpublication)}}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'teacher_book',
  props: ['teacher', 'teacherpublications'],
  data() {
    return {
      teacherId: this.$route.params.teacherid,
      info: {},
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {},
  methods: {
    publication(teacherpublication) {
      if (teacherpublication.publicationAt) {
        let dateArr = teacherpublication.publicationAt.split(' ')[0].split('-');
        return dateArr[0];
      }
      return ''
    },
    

    showReviewSystem(teacherpublication) {
      let showCH = { 0: '無', 1: '有' },
        showEN = { 0: 'nonexist', 1: 'exist' },
        show = { CH: showCH[teacherpublication.reviewSystem], EN: showEN[teacherpublication.reviewSystem] };
      return show[sessionStorage.locale];
    },
    showName(teacherpublication) {
      let name = { 'CH': teacherpublication.nameCh, 'EN': teacherpublication.nameEn }
      return name[sessionStorage.locale];
    },
  },
}

</script>
<style lang="scss">
#teacher_book {
  table {
    tr {
      td {
        padding: 10px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// TeacherBook.vue?308d0a70